import SignUpLayout from 'components/auth/components/SignUpLayout';
import LoginPageComponent from 'components/auth/pages/LoginPage';
import { initFirebase } from 'stacks/messaging/Firebase';
import boatsetterPaths, { boatsetterFlags } from 'utils/boatsetterPaths';
import withFeatureFlagRouting from 'utils/withFeatureFlagRouting';

initFirebase();

export const getServerSideProps = withFeatureFlagRouting({
  flagName: boatsetterFlags.clerkSignup,
  destination: boatsetterPaths.auth.root,
  redirectWhen: 'enabled',
});

export default function LoginPage() {
  return (
    <SignUpLayout>
      <LoginPageComponent />
    </SignUpLayout>
  );
}
